/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

 // You can delete this file if you're not using it

import ReactGA from 'react-ga';

// Initialize ReactGA when user first visits site
exports.onClientEntry = () => {
  ReactGA.initialize('UA-13226656-10')
}

// Each time a page or state gets updated, send route to ReactGA
exports.onRouteUpdate = (state, page, pages) => {
  ReactGA.pageview(window.location.href)
}



// WEBPACK FOOTER //
// ./gatsby-browser.js